import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { types } from './types';

export default function NavigationListener() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const path = useSelector(state => state.NavigationReducer.path);

    useEffect(() => {
        if (path) {
            navigate(path);
            dispatch({ type: types.CLEAR_NAVIGATION });
        }
    }, [path, navigate, dispatch]);

    return null;
}
